import axiosInstance from "../axios/axiosInstance";
import { ITopicFormInput } from "../../Pages/Topic/Topic.model";
import { buildApiUrl } from "../../config/api";

const API = buildApiUrl("/interviewQuestionApp/topics/");

export const TopicService = {
  async getTopics(activeOnly: boolean = false) {
    const url = activeOnly ? `${API}?is_active=true` : API;
    return axiosInstance.get(url);
  },
  async create(payload: ITopicFormInput) {
    return axiosInstance.post(API, payload);
  },
  async update(id: number, data: ITopicFormInput) {
    try {
      const res = await axiosInstance.put(`${API}${id}/`, data);
      return { success: true, data: res.data };
    } catch (err: any) {
      return {
        success: false,
        errors: err.response?.data || {},
      };
    }
  },
  async remove(id: number) {
    try {
      const res = await axiosInstance.delete(`${API}${id}/`);
      return { success: true, data: res };
    } catch (err: any) {
      return {
        success: false,
        errors: err.response?.data || {},
      };
    }
  },
};
